const  breakPoint = 768;
let resizeFlag    = false
let windowWidth   = window.innerWidth;
let windowHeight  = window.innerHeight;
let windowWidthJQ = $(window).width();



// -------------------------------------------------------------------
// loadFonts
// →
// -------------------------------------------------------------------
const loadFonts = () => {
  const $targetLink      = $('a:not([href^="#"]):not([target]):not([href^="mailto:contact@vistec.co.jp"]):not([href^="tel:"])');
  const $targetLoad      = $('#load');
  const $targetContainer = $('#container');
  $targetLink.on('click', function(e){
    e.preventDefault();
    let targetUrl = $(this).attr('href');
    if (targetUrl !== '') {
      $targetLoad.removeClass('is-Loaded');
      $targetLoad.addClass('is-Loading');
      setTimeout(function(){
        window.location = targetUrl;
      }, 650);
    }
    return false;
  });
  window.addEventListener('load',function(){
    $targetLoad.removeClass('is-Loading');
    $targetLoad.addClass('is-Loaded');
    setTimeout(() => {
      $targetContainer.removeClass('is-Loading');
      $targetContainer.addClass('is-Loaded');
    }, 50);
  });
  window.onpageshow = function(e) {
    if (e.persisted) {
      window.location.reload();
    }
  };
}



// -------------------------------------------------------------------
// detectionScroll
// →
// -------------------------------------------------------------------
const detectionScroll = () => {
  let targetHeader = document.getElementById('header');
  let targetTotop  = document.getElementById('totop');
  let targetHeight = 120;
  window.addEventListener('scroll', () => {
    let scrollVolume = window.pageYOffset;
    if (scrollVolume > targetHeight) {
      targetHeader.classList.add('is-Scrolled');
      targetTotop.classList.add('is-Scrolled');
    } else {
      targetHeader.classList.remove('is-Scrolled');
      targetTotop.classList.remove('is-Scrolled');
    }
  }, false);
};



// -------------------------------------------------------------------
// switchServices
// →
// -------------------------------------------------------------------
const switchServices = () => {
  let targetButton  = document.getElementById('servicesSwitchsButton');
  let targetContent = document.getElementById('headerServicesContent');
  if(windowWidth > breakPoint){
    targetButton.addEventListener('mouseenter', () => {
      targetButton.classList.remove('is-Close');
      targetContent.classList.remove('is-Close');
    }, false);
    targetButton.addEventListener('mouseleave', () => {
      targetButton.classList.add('is-Close');
      targetContent.classList.add('is-Close');
    }, false);
    targetContent.addEventListener('mouseenter', () => {
      targetButton.classList.remove('is-Close');
      targetContent.classList.remove('is-Close');
    }, false);
    targetContent.addEventListener('mouseleave', () => {
      targetButton.classList.add('is-Close');
      targetContent.classList.add('is-Close');
    }, false);
  }
};



// -------------------------------------------------------------------
// switchHeader
// →
// -------------------------------------------------------------------
const switchHeader = () => {
  let targetButton  = document.getElementById('headerSwitchButton');
  let targetContent = document.getElementById('headerSwitchContent');
  if(windowWidth <= breakPoint){
    targetButton.addEventListener('click', () => {
      if(targetButton.classList.contains('is-Open')){
        targetButton.classList.remove('is-Open');
        targetContent.classList.remove('is-Open');
      } else {
        targetButton.classList.add('is-Open');
        targetContent.classList.add('is-Open');
      }
    }, false);
  }
}



// -------------------------------------------------------------------
// tilePost
// →
// -------------------------------------------------------------------
const tilePost = () => {
  $(window).on('load resize' , function() {
    $('.st-Post_List_Item_Title').tile();
  });
};



// -------------------------------------------------------------------
// anchorScroll
// →
// -------------------------------------------------------------------
const anchorScroll = () => {
  const $anchor = $('a[href^=#]');
  $anchor.click(function () {
    let speed    = 850;
    let href     = $(this).attr('href');
    let target   = $(href == '#' || href == '' ? 'html' : href);
    let position = target.offset().top;
    if(windowWidthJQ > breakPoint){
      position = target.offset().top - 92;
    }else{
      position = target.offset().top - windowWidthJQ * 0.1825;
    }
    $('html, body').animate({
      scrollTop: position
    }, speed, 'swing');
    return false;
  });
};



export { loadFonts, detectionScroll, switchHeader, switchServices, tilePost, anchorScroll };



// WEBPACK FOOTER //
// module.js